import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Assignment } from '@material-ui/icons';
import moment from 'moment';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { WithApp } from 'contexts/appContext';
import { wsUpdate } from 'services/WService';
import { currency } from 'hooks/Pipe';
import { onlyInteger } from 'hooks/Pipe';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'baseline',
  },
  headerCard: {
    fontSize: '.9em',
    '& .totals': {
      marginLeft: '20px',
      color: 'black',
    },
  },
  loader: {
    marginLeft: '20px',
  },
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'Código', accessor: 'ItemCode', width: 100 },
  { Header: 'Producto', accessor: 'ItemName' },
  { Header: 'Cantidad UM', accessor: 'Fac_UM', hidden: true },
  { Header: 'Comentario', accessor: 'comentario', width: 160, excelEnabled: false },
  { Header: 'Fecha corta', accessor: 'fec_corta', width: 120, excelEnabled: false },
  { Header: 'Cantidad Corta', accessor: 'cant_prod_corta', width: 140, excelEnabled: false },
  { Header: 'UM', accessor: 'UM', width: 100 },
  { Header: 'P. Unit', accessor: 'unit_price', width: 120 },
  { Header: 'Stock actual', accessor: 'stock_actual', width: 120 },
  { Header: 'conteo', accessor: 'conteo', hidden: true },
  { Header: 'conteo1', accessor: 'conteo1', hidden: true },
  { Header: 'conteo2', accessor: 'conteo2', hidden: true },
  { Header: 'Fecha vencimiento', accessor: 'fecha_vencimiento', hidden: true },
  { Header: 'Cantidad', accessor: 'cantidad_ingresada', width: 120, excelEnabled: false },
  { Header: 'Diferencia', accessor: 'diferencia', width: 120, excelEnabled: false },
  { Header: 'Monto', accessor: 'total', width: 130, excelEnabled: false },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const classes = useStyles();
  const {
    entity,
    dataChanging,
    productSelecteds,
    setProductSelecteds,
    showNotify,
    getTransfer,
    stateK,
    showProdStock,
  } = props;
  const [dataLoading, setDataLoading] = useState(false);
  const [productCount, setProductCount] = useState(0);
  
  const calculateStockAndTotal = (product, diferencia) => {
    const diff = diferencia === null || diferencia === undefined ? 0 : diferencia;
    
    let stockDisponible = parseInt(product?.OnHand || 0, 10);
    let cantidad_ingresada = Math.max( 0,
      diff === 0 && stockDisponible > 1
        ? stockDisponible
        : stockDisponible + diff
    );
    let total = Math.max(0, (product?.last_purchase_price || 0) * cantidad_ingresada);
    return { cantidad_ingresada, total };
  };
  
  const handleChangeRow = (e, detailId, field) => {
    let cloneRows = [...productSelecteds];
    let objIndex = cloneRows.findIndex((obj) => obj.id === detailId);
    if (objIndex === -1) {
      console.error(`⛔ Detalle con ID ${detailId} no encontrado`, cloneRows);
      return;
    }
    let newValue;
    if (field === 'diferencia') {
      if (e.target.value === '') {
        newValue = '';
      }
      else if (e.target.value) {
        newValue = e.target.value;
      } else {
        return;
      }
    } else {
      newValue = e.target.value;
    }
    cloneRows[objIndex][field] = newValue;
    if (field === 'diferencia' && newValue !== '') {
      const numValue = parseInt(newValue, 10) || 0;
      let { cantidad_ingresada, total } = calculateStockAndTotal(cloneRows[objIndex], numValue);
      cloneRows[objIndex].cantidad_ingresada = cantidad_ingresada;
      cloneRows[objIndex].total = total;
    }
    setProductSelecteds([...cloneRows]);
  };

  async function updateDetail(detailId, data) {
    if (!detailId) {
      console.error("⛔ No se puede actualizar detalle sin ID:", data);
      return;
    }
    if (data.diferencia !== undefined) {
      data.diferencia = parseInt(data.diferencia, 10) || 0;
      let detalle = productSelecteds.find((p) => p.id === detailId);
      if (detalle) {
        let { cantidad_ingresada, total } = calculateStockAndTotal(detalle, data.diferencia);
        data.cantidad_ingresada = cantidad_ingresada;
        data.total = total;
      }
    }
    let response = await wsUpdate(`${entity}/${dataChanging.id}/detail/${detailId}`, data);
    if (response.success) {
      showNotify(response.message);
    } else {
      getTransfer(dataChanging.id);
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (!dataChanging || !Array.isArray(dataChanging.details)) {
      console.warn("⚠ dataChanging.details no es un array o no existe.");
      setProductSelecteds([]);
      return;
    }
  
    // console.log("🔄 Cargando productos seleccionados...");
  
    const selectedProducts = dataChanging.details
      .flatMap((detail) =>
        (detail.marks || []).flatMap((mark) =>
          (mark.lines || []).flatMap((line) =>
            (line.families || []).flatMap((family) =>
              (family.details || []).filter((prod) =>
                Array.isArray(dataChanging.products) &&
                dataChanging.products.includes(parseInt(prod.logi_product_id))
              )
            )
          )
        )
      )
      .map((product) => ({
        ...product,
        cantidad_ingresada: product.cantidad_ingresada || 0,
        diferencia: product.diferencia || 0,
        comentario: product.comentario || "",
      }));
  
    if (selectedProducts.length > 0) {
      // console.log("🟢 Productos seleccionados:", selectedProducts);
      setProductSelecteds(selectedProducts);
      setProductCount(selectedProducts.length); // Guardamos la cantidad
    } else {
      console.warn("⚠ No hay productos seleccionados, usando los del detalle.");
    
      const fallbackProducts = dataChanging.details
        .flatMap((detail) =>
          (detail.marks || []).flatMap((mark) =>
            (mark.lines || []).flatMap((line) =>
              (line.families || []).flatMap((family) => family.details || [])
            )
          )
        )
        .map((product) => ({
          ...product,
          cantidad_ingresada: product.cantidad_ingresada || 0,
          diferencia: product.diferencia || 0,
          comentario: product.comentario || "",
        }));
    
      // console.log("🟢 Usando productos de details:", fallbackProducts);
      setProductSelecteds(fallbackProducts);
      setProductCount(fallbackProducts.length); // Guardamos la cantidad
    }
  }, [dataChanging.products, dataChanging.details]);

  useEffect(() => {
    if (showProdStock) {
      setProductCount(productSelecteds.length);
    } else {
      const filtered = productSelecteds.filter(p => (p.OnHand ?? p.stock_actual ?? 0) > 0);
      setProductCount(filtered.length);
    }
  }, [productSelecteds, showProdStock]);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <div className={classes.cardIconTitle}>Vista detalle de productos seleccionados
              <div className={classes.headerCard}>
                <span className="totals">Total de productos: ({productCount})</span>
              </div>
              <div className={classes.loader}>
                {dataLoading && <LoadingSpinner />}
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="inventario_detalle"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={(showProdStock 
                ? productSelecteds 
                : productSelecteds.filter(p => (p.OnHand ?? p.stock_actual ?? 0) > 0)
              ).map((product, i) => {
                return {
                  ...product,
                  diferenciaRaw: product.diferencia ?? 0,
                  num: (
                    <div className="actions-right">
                      {i + 1}
                    </div>
                  ),
                  ItemCode: product.ItemCode,
                  ItemName: product.ItemName,
                  comentario: (
                    <AllowedGuard
                      permission={ConstantPermissions.LOGI_INVENTORIES_UPDATE}
                      component={product.comentario}
                    >
                      <TextField
                        fullWidth
                        type="text"
                        name="comentario"
                        margin="normal"
                        value={product.comentario || ""}
                        onChange={(e) => handleChangeRow(e, product.id, 'comentario')}
                        onBlur={(e) => {
                          let newValue = e.target.value;
                          updateDetail(product.id, { comentario: newValue });
                        }}
                        required
                        disabled={stateK}
                      />
                    </AllowedGuard>
                  ),
                  comentario_string: product.comentario || '',
                  fec_corta: (
                    <AllowedGuard
                      permission={ConstantPermissions.LOGI_INVENTORIES_UPDATE}
                      component={product.fec_corta}
                    >
                      <TextField
                        fullWidth
                        type="date"
                        name="fec_corta"
                        margin="normal"
                        value={product.fec_corta || ""}
                        onChange={(e) => handleChangeRow(e, product.id, 'fec_corta')}
                        onBlur={(e) => {
                          let newValue = e.target.value;
                          updateDetail(product.id, { fec_corta: newValue });
                        }}
                        InputProps={{
                          inputProps: {
                            min: moment().format('YYYY-MM-DD')
                          }
                        }}
                        required
                        disabled={stateK}
                      />
                    </AllowedGuard>
                  ),
                  fec_corta_string: product.fec_corta || '',
                  cant_prod_corta: (
                    <AllowedGuard
                      permission={ConstantPermissions.LOGI_INVENTORIES_UPDATE}
                      component={product.cant_prod_corta}
                    >
                      <TextField
                        name="cant_prod_corta"
                        value={product.cant_prod_corta ?? ""}
                        onChange={(e) => {
                          let newValue = parseInt(e.target.value, 10) || 0;
                          if (newValue < 0) newValue = 0;
                          if (newValue > product.OnHand) newValue = product.OnHand;
                          handleChangeRow(
                            { target: { name: "cant_prod_corta", value: newValue } },
                            product.id, "cant_prod_corta"
                          );
                        }}
                        onBlur={(e) => {
                          let newValue = parseInt(e.target.value, 10) || 0;
                          if (newValue < 0) newValue = 0;
                          if (newValue > product.OnHand) newValue = product.OnHand;
                          updateDetail(product.id, { cant_prod_corta: newValue });
                        }}
                        margin="normal"
                        inputProps={{ min: 0 }}
                        onKeyPress={onlyInteger}
                        type="number"
                        fullWidth
                        disabled={stateK}
                      />
                    </AllowedGuard>
                  ),
                  cant_prod_corta_string: product.cant_prod_cort || '',
                  UM: 'PZA (1)',
                  unit_price: product.last_purchase_price,
                  stock_actual: product.OnHand || 0,
                  cantidad_ingresada: product.diferencia === 0 && parseInt(product.OnHand) > 1
                  ? parseInt(product.OnHand)
                  : product.cantidad_ingresada || '-',
                  diferencia: (
                    <AllowedGuard permission={ConstantPermissions.LOGI_INVENTORIES_UPDATE} component={product.diferencia}>
                      <TextField
                        name="diferencia"
                        value={product.diferencia ?? ""}
                        onChange={(e) => handleChangeRow(e, product.id, "diferencia")}
                        onBlur={(e) => {
                          let newValue = e.target.value === '' ? 0 : parseInt(e.target.value, 10) || 0;
                          let { cantidad_ingresada, total } = calculateStockAndTotal(product, newValue);
                          updateDetail(product.id, {
                            diferencia: newValue,
                            cantidad_ingresada,
                            total
                          });
                        }}
                        margin="normal"
                        type="number"
                        fullWidth
                        disabled={stateK}
                      />
                    </AllowedGuard>
                  ),
                  diferencia_string: product.diferencia || '',
                  total: currency(Math.max(0, product.last_purchase_price * product.cantidad_ingresada)) || "S/0.00",
                  actions: '',
                };
              })}
              colorRow={(item) => {
                const diferencia = parseFloat(item.diferenciaRaw);
                if (diferencia > 0) return '#43ff6b61'; // Verde
                if (diferencia < 0) return '#ff980073'; // Naranja
                return ''; // Sin color
              }}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
